<!--
 * @Description: Description
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-08-28 13:44:46
 * @LastEditors: FJW
 * @LastEditTime: 2024-12-13 17:15:24
-->
<template>
  <el-container class="chat-page">
    <el-aside width="260px" class="chat-list-box">
      <div class="chat-list-header">
        <el-input class="search-text" placeholder="搜索" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
      </div>
      <div class="chat-list-loadding" v-if="loading" v-loading="true" element-loading-text="消息接收中..." element-loading-spinner="el-icon-loading" element-loading-background="#eee">
        <div class="chat-loading-box"></div>
      </div>
      <el-scrollbar class="chat-list-items">
        <div v-for="(chat,index) in chatStore.chats" :key="index">
          <chat-item v-show="chat.showName.startsWith(searchText)" :chat="chat" :index="index" @click.native="onActiveItem(index,chat,'handle')" @delete="onDelItem(index)" @top="onTop(index)" :active="chat === chatStore.activeChat"></chat-item>
        </div>
      </el-scrollbar>
    </el-aside>
    <el-container class="chat-box">
      <chat-box v-if="chatStore.activeChat" :chat="chatStore.activeChat" ref="chatBox"></chat-box>
      <shop-detail v-if="chatStore.activeChat" ref="shopDetail" @sendRichTextMessage="sendRichTextMessage" @sendRichTextOrder="sendRichTextOrder"></shop-detail>
    </el-container>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue"
import ChatBox from "../components/chat/ChatBox.vue"
import ShopDetail from '../components/ShopDetail/index.vue'


export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ShopDetail
  },
  data() {
    return {
      searchText: "",
      messageContent: "",
      group: {},
      groupMembers: [],
      targetIndex: null
    }
  },
  watch: {
    '$route.query.kmallUserId': {
      handler(kmallUserId, oldId) {

        kmallUserId = Number(kmallUserId)
        if (!kmallUserId) return
        const processChat = () => {
          const targetChat = this.chatStore.chats.find((chat, index) => {
            if (chat.kmallUserId === kmallUserId) {
              this.targetIndex = index;
              return true;
            }
          });
          if (targetChat) {
            this.onActiveItem(this.targetIndex, targetChat);
          } else {
            const findFriendObj = this.$store.state.friendStore.friends.find(v => v.kmallUserId === kmallUserId);
            if (findFriendObj) {
              this.onSendMessage(findFriendObj);
            } else {
              if (window.performance.getEntriesByType("navigation")[0].type !== "reload") {
                this.$message.error("未找到用户")
              }
            }
          }
        };

        if (!this.$store.state.chatStore.chats.length) {
          this.$store.dispatch('load').then(processChat).catch(err => err)
        } else {
          processChat();
        }
      },
      immediate: true
    }
  },
  methods: {
    onSendMessage(user) {
      let chat = {
        type: 'PRIVATE',
        targetId: user.id,
        showName: user.nickName,
        headImage: user.headImageThumb,
      };
      this.$store.commit("openChat", chat);
      this.$store.commit("activeChat", 0);
      this.$router.push("/home/chat");
    },
    sendRichTextOrder(data) {
      this.$refs.chatBox.sendRichTextMessage(data, 8)
    },

    sendRichTextMessage(data) {
      this.$refs.chatBox.sendRichTextMessage(data, 7)
    },

    clearKmallUserIdList(type) {
      if (type === 'handle') {
        if (this.$route.query.kmallUserId) {
          this.$router.replace({ path: this.$route.path, query: {} });
        }
      }
    },

    onActiveItem(index, chat, type) {
      this.$store.commit("activeChat", index)
      this.clearKmallUserIdList(type)
      this.$nextTick(() => {
        const kmallUserId = chat.kmallUserId
        this.$refs.shopDetail.$refs.orderRef.kmallUserId = kmallUserId
        this.$refs.shopDetail.$refs.orderRef.getShopDetail()
        this.$refs.shopDetail.$refs.historyRef.kmallUserId = kmallUserId
        this.$refs.shopDetail.$refs.historyRef.getHistoryDetail()
        this.$refs.shopDetail.$refs.customerRef.currentUserId = chat.targetId
      })
    },
    onDelItem(index) {
      this.$store.commit("removeChat", index);
    },
    onTop(chatIdx) {
      this.$store.commit("moveTop", chatIdx);
    },
  },
  computed: {
    chatStore() {
      return this.$store.state.chatStore;
    },
    loading() {
      return this.chatStore.loadingGroupMsg || this.chatStore.loadingPrivateMsg
    }
  }
}
</script>

<style lang="scss">
.chat-page {
  .chat-list-box {
    display: flex;
    flex-direction: column;
    border: #dddddd solid 1px;
    background: white;
    width: 3rem;

    .chat-list-header {
      padding: 3px 8px;
      line-height: 50px;
      border-bottom: 1px #ddd solid;

      .el-input__inner {
        border-radius: 10px !important;
        background-color: #f0f2f5;
      }
    }

    .chat-list-loadding {
      height: 50px;
      background-color: #eee;

      .chat-loading-box {
        height: 100%;
      }
    }

    .chat-list-items {
      flex: 1;
      background: #f0f2f5;
      margin: 0 3px;
    }
  }
}
</style>